var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"md-layout"},[_c('div',{staticClass:"md-layout-item"},[_c('edit-profile-form',{attrs:{"data-background-color":"primary"}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }